import { server } from "./axios";

const baseURL = "https://dbp.bcc.kz/v1/dbp/deferral"

export class CamundaController {
  async start(variables: any, token: string): Promise<any> {
    console.log("start");
    return server.postFree(
      `/run`,
      {
        ...variables,
      },
      {
        baseURL: baseURL,
        headers: {
          Authorization: token
        }
      }
    );
  }
}
